(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
    /* =========================================================
     Opening introduction
     ========================================================= */

  const intro = $('[data-intro]');
  const introSkip = $('[data-intro-skip]');

  function closeIntro() {
    if (!intro) return;

    intro.classList.add('is-hidden');
    intro.setAttribute('aria-hidden', 'true');

    try {
      window.localStorage.setItem('ei_intro_seen', '1');
    } catch (error) {
      // Storage may be unavailable in private browsing.
    }
  }

  function initIntro() {
    if (!intro) return;

    let alreadySeen = false;

    try {
      alreadySeen = window.localStorage.getItem('ei_intro_seen') === '1';
    } catch (error) {
      alreadySeen = false;
    }

    if (alreadySeen) {
      closeIntro();
      return;
    }

    introSkip?.addEventListener('click', closeIntro);

    window.setTimeout(closeIntro, 2200);
  }

  initIntro();
  const rootUrl = (window.EI && window.EI.root) || '/';
  const route = (path) => `${rootUrl}${path}`.replace(/\/+/g, '/');
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR', maximumFractionDigits: 0 }).format(cents / 100);

  function toast(message) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.add('show');
    clearTimeout(toast.timer);
    toast.timer = setTimeout(() => el.classList.remove('show'), 2600);
  }

  const menu = $('[data-menu]');
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('open', open);
    menu.setAttribute('aria-hidden', String(!open));
    $('[data-menu-open]')?.setAttribute('aria-expanded', String(open));
    $('.site-backdrop')?.classList.toggle('show', open);
    document.body.classList.toggle('locked', open);
  }
  $('[data-menu-open]')?.addEventListener('click', () => setMenu(true));
  $$('[data-menu-close]').forEach((button) => button.addEventListener('click', () => setMenu(false)));

  const drawer = $('[data-cart-drawer]');
  async function getCart() {
    const response = await fetch(route('cart.js'), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load your bag.');
    return response.json();
  }
  function updateCount(count) { $$('[data-cart-count]').forEach((el) => { el.textContent = count; }); }
  function renderCart(cart) {
    updateCount(cart.item_count);
    const lines = $('[data-cart-lines]');
    const summary = $('[data-cart-summary]');
    if (!lines || !summary) return;
    if (!cart.items.length) {
      lines.innerHTML = '<div class="cart-empty"><p>Your edit is waiting.</p><a class="line-link" href="/collections/all">Explore pieces ↗</a></div>';
      summary.hidden = true;
      return;
    }
    lines.innerHTML = cart.items.map((item) => {
      const properties = Object.entries(item.properties || {}).filter(([, value]) => value).map(([key, value]) => `<small>${escapeHtml(key)}: ${escapeHtml(value)}</small>`).join('');
      const image = item.image ? `<a href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.image)}&width=220" alt="${escapeHtml(item.product_title)}" loading="lazy"></a>` : '<div></div>';
      return `<article class="cart-line">${image}<div><h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3><p>${escapeHtml(item.variant_title || '')}</p>${properties}<button type="button" data-remove-line="${escapeHtml(item.key)}">Remove</button></div><strong>${money(item.final_line_price)}</strong></article>`;
    }).join('');
    $('[data-cart-total]').textContent = money(cart.total_price);
    summary.hidden = false;
    $$('[data-remove-line]', lines).forEach((button) => button.addEventListener('click', async () => {
      button.disabled = true;
      try {
        const response = await fetch(route('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: button.dataset.removeLine, quantity: 0 }) });
        if (!response.ok) throw new Error('Unable to remove this piece.');
        renderCart(await response.json());
      } catch (error) { toast(error.message); button.disabled = false; }
    }));
  }
  async function setCart(open) {
    if (!drawer) return;
    if (open) {
      drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
      $('.cart-backdrop')?.classList.add('show'); document.body.classList.add('locked');
      try { renderCart(await getCart()); } catch (error) { toast(error.message); }
    } else {
      drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
      $('.cart-backdrop')?.classList.remove('show'); document.body.classList.remove('locked');
    }
  }
  $$('[data-cart-open]').forEach((button) => button.addEventListener('click', () => setCart(true)));
  $$('[data-cart-close]').forEach((button) => button.addEventListener('click', () => setCart(false)));

  const productRoot = $('[data-product-root]');
  if (productRoot) {
    const form = $('#ProductForm', productRoot);
    const variantsScript = $('[data-product-json]', productRoot);
    const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    const optionButtons = $$('[data-option-position]', productRoot);
    function chooseVariant() {
      if (!variants.length) return;
      const selected = [];
      const positions = [...new Set(optionButtons.map((button) => button.dataset.optionPosition))];
      positions.forEach((position) => selected.push($(`[data-option-position="${position}"].selected`, productRoot)?.dataset.optionValue));
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selected[index]));
      if (!variant) return;
      $('[data-variant-id]', form).value = variant.id;
      $('[data-product-price]').textContent = money(variant.price);
      const addButton = $('[data-add-button]', form);
      addButton.disabled = !variant.available;
      addButton.firstChild.textContent = variant.available ? 'Add to bag ' : 'Sold out ';
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    }
    optionButtons.forEach((button) => button.addEventListener('click', () => {
      $$(`[data-option-position="${button.dataset.optionPosition}"]`, productRoot).forEach((item) => item.classList.remove('selected'));
      button.classList.add('selected'); chooseVariant();
    }));
    const customToggle = $('[data-custom-toggle]', form);
    customToggle?.addEventListener('change', () => { $('[data-custom-fields]', form).hidden = !customToggle.checked; });
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const addButton = $('[data-add-button]', form);
      addButton.disabled = true;
      try {
        const response = await fetch(route('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this piece.');
        toast(`${result.product_title || 'Piece'} added to your bag`);
        await setCart(true);
      } catch (error) { toast(error.message); }
      finally { addButton.disabled = false; }
    });
  }

  const sizeModal = $('[data-size-modal]');
  function setSize(open) {
    if (!sizeModal) return;
    sizeModal.classList.toggle('open', open); sizeModal.setAttribute('aria-hidden', String(!open));
    $('.size-modal-backdrop')?.classList.toggle('show', open); document.body.classList.toggle('locked', open);
    if (open) sizeModal.querySelector('button')?.focus();
  }
  $$('[data-size-open]').forEach((button) => button.addEventListener('click', () => setSize(true)));
  $$('[data-size-close]').forEach((button) => button.addEventListener('click', () => setSize(false)));
  if (location.hash === '#size-guide') setSize(true);

  $('[data-sort-select]')?.addEventListener('change', (event) => { const url = new URL(location.href); url.searchParams.set('sort_by', event.target.value); location.assign(url); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { setMenu(false); setCart(false); setSize(false); } });
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('visible'); }), { threshold: .08 });
  $$('[data-reveal]').forEach((el) => observer.observe(el));
})();
